import { clsx } from 'clsx'
import { PropsWithChildren } from 'react'

interface PageProps extends PropsWithChildren {
  className?: string
}

export function Page({ className, children }: PageProps): React.JSX.Element {
  return <div className={clsx('relative flex flex-1 flex-col px-6 max-tablet:px-5', className)}>{children}</div>
}
